<template>
  <div class="animated revealUp" style="zoom: 0.9">
    <div class="d-flex col-12 justify-content-between">
      <div
        class="wrap d-flex align-items-center mt-3"
        style="margin-bottom: 10px; gap: 15px; width: 610px"
      >
        <!-- <div>
          <div class="section-title" style="white-space: nowrap">
            {{ $t("fnbitems") }}
          </div>
        </div> -->

        <!-- <div class="" style="width: 40%">
          <multiselect
            v-model="cinemasSelected"
            :placeholder="'Cinema'"
            :options="Cinemas"
            @select="onSelectCinema($event)"
            @remove="onRemoveCinema($event)"
            selectLabel="Select"
            deselectLabel="✖"
            label="cine_name"
            track-by="cine_id"
            :multiple="false"
          ></multiselect>
        </div> -->
        <!-- <div style="min-width: 200px">
          <b-form-input
            v-model="searchValue"
            v-debounce:800="searchFnbItem"
            placeholder="Search..."
            :style="'border-radius: 10px;width:300px'"
          ></b-form-input>
        </div> -->
      </div>
      <div
        class="wrap d-flex align-items-center mt-3 ml-3"
        style="margin-bottom: 10px; gap: 15px"
      >
        <div class="d-flex align-items-center" v-if="!copyMenuFlag">
          <!-- <FilterByStatusDropdown
            ref="statusDropDown"
            :onSelect="
              (filterIsActive) => {
                onSwitchActive(filterIsActive);
                // getFnbItems();
              }
            "
          /> -->
          <!-- <div class="" style="min-width: 200px">
            <multiselect
              v-model="selectedTypeFilter"
              :placeholder="'Filter'"
              :options="fillterArray"
              label="name"
              track-by="id"
              :multiple="false"
              @select="onSelectFilterType($event, 'SELECT')"
              @remove="onSelectFilterType($event, 'REMOVE')"
            ></multiselect>
          </div> -->

          <!-- <b-button
            v-if="$can('create', 'F&B item')"
            variant="default"
            to="add-fnb-item"
            class="btn-blue"
            >{{ $tc("add") }}</b-button
          > -->

          <!-- <button
            class="btnj btn-gridView ml-3"
            :class="gridView ? 'active' : ''"
            v-on:click="viewType('gridView')"
          ></button>
          <button
            class="icon-calendar_list blue-icon ml-2 btn"
            :class="listView ? 'active' : ''"
            v-on:click="viewType('listView')"
          ></button> -->
          <!-- <b-dropdown
            size="sm"
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
            v-if="!copyMenuFlag"
          >
            <template #button-content>
              <img
                :title="'Settings'"
                src="@/assets/img/icons/copy.svg"
                style="width: 30px"
              /> -->
          <!-- <span
              class="icon-settings blue-icon mx-1 btn float-right"
              :title="'Settings'"
            ></span> -->
          <!-- </template>
            <b-dropdown-item @click="onClickCopyMenuOption"
              >Copy Menu</b-dropdown-item
            >
          </b-dropdown> -->
        </div>

        <!-- <div class="d-flex align-items-center" v-else-if="copyMenuFlag">
          <div class="d-flex justify-content-end align-item-center my-2">
            <button
              class="btn btn-sm btn-blue br-20"
              :class="selectedFnbItems.length == 0 ? 'disDeleteBtn' : ''"
              :disabled="selectedFnbItems.length == 0"
              @click="onClickCopyItems()"
            >
              ({{ selectedFnbItems.length }}) Copy Items
            </button>
            <button
              class="btn btn-sm btn-outline-blue br-20"
              @click="onCancelCopyMenu"
            >
              Cancel
            </button>
          </div>
        </div> -->

        <div class="d-flex mx-2">
          <!-- <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content> -->
          <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
          <!-- <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown> -->
          <!-- <b-button variant="default" @click="onFetch()" class="btn-blue">{{
            $t("fetch")
          }}</b-button> -->
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6 col-lg-1 d-flex align-items-center my-2">
        <div class="section-title" style="white-space: nowrap">
          {{ $t("fnbitems") }}
        </div>
      </div>

      <div
        class="d-flex align-items-center ml-2 col-12 col-md-6 col-lg-2 mx-2 my-2"
      >
        <multiselect
          v-model="cinemasSelected"
          :placeholder="'Cinema'"
          :options="Cinemas"
          @select="onSelectCinema($event)"
          @remove="onRemoveCinema($event)"
          selectLabel="Select"
          deselectLabel="✖"
          label="cine_name"
          track-by="cine_id"
          :multiple="false"
        ></multiselect>
      </div>
      <div class="d-flex align-items-center col-12 col-md-6 col-lg-2 mx-2 my-2">
        <b-form-input
          v-model="searchValue"
          v-debounce:800="searchFnbItem"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div
        class="d-flex col-4 col-md-2 col-lg-1 align-items-center justify-content-between my-2"
        v-if="!copyMenuFlag"
      >
        <FilterByStatusDropdown
          ref="statusDropDown"
          :onSelect="
            (filterIsActive) => {
              onSwitchActive(filterIsActive);
              // getFnbItems();
            }
          "
        />
      </div>
      <div
        v-if="!copyMenuFlag"
        class="d-flex justify-content-between align-items-center col-6 col-md-6 col-lg-2 my-2"
      >
        <multiselect
          v-model="selectedTypeFilter"
          :placeholder="'Filter'"
          :options="fillterArray"
          label="name"
          track-by="id"
          :multiple="false"
          @select="onSelectFilterType($event, 'SELECT')"
          @remove="onSelectFilterType($event, 'REMOVE')"
        ></multiselect>
      </div>
      <div
        v-if="!copyMenuFlag"
        class="d-flex aling-items-center col-6 col-md-6 col-lg-2 my-2 py-2"
      >
        <button
          class="btnj btn-gridView ml-3"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="icon-calendar_list blue-icon ml-2 btn"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
        <b-dropdown
          size="sm"
          variant="link"
          toggle-class="text-decoration-none"
          no-caret
          v-if="!copyMenuFlag"
        >
          <template #button-content>
            <img
              :title="'Settings'"
              src="@/assets/img/icons/copy.svg"
              style="width: 30px"
            />
            <!-- <span
              class="icon-settings blue-icon mx-1 btn float-right"
              :title="'Settings'"
            ></span> -->
          </template>
          <b-dropdown-item @click="onClickCopyMenuOption"
            >Copy Menu</b-dropdown-item
          >
        </b-dropdown>
      </div>
      <div v-if="!copyMenuFlag" class="col-6 col-md-6 col-lg-1 my-2">
        <b-dropdown id="listview" variant="outline-blue">
          <template v-slot:button-content>
            <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
            <strong>{{ viewingRange }}</strong>
          </template>
          <b-dropdown-item
            v-for="(list, listIndex) in viewingnumbers"
            :key="listIndex"
            @click="onDropDownChangeValue(list.name)"
            href="#"
            >{{ list.name }}</b-dropdown-item
          >
        </b-dropdown>
      </div>
      <div class="d-flex align-items-center" v-else-if="copyMenuFlag">
        <div class="d-flex justify-content-end align-item-center my-2">
          <button
            class="btn btn-sm btn-blue br-20"
            :class="selectedFnbItems.length == 0 ? 'disDeleteBtn' : ''"
            :disabled="selectedFnbItems.length == 0"
            @click="onClickCopyItems()"
          >
            ({{ selectedFnbItems.length }}) Copy Items
          </button>
          <button
            class="btn btn-sm btn-outline-blue br-20"
            @click="onCancelCopyMenu"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
    <div class="row d-flex justify-content-end align-items-center my-2">
      <div class="d-flex justify-content-end my-3 align-items-center">
        <div class="mr-1" style="white-space: nowrap">
          {{ $t("download") }} as:
        </div>
        <!-- <a target="_blank" download title="Download as PDF">
                  <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
                </a> -->
        <a
          :href="BASE_URL + `/api/admin/export_fnb_list${queryString}`"
          target="_blank"
          title="Download as Excel"
          download
        >
          <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
        </a>
      </div>
      <b-button
        v-if="$can('create', 'F&B item')"
        variant="default"
        to="add-fnb-item"
        class="btn-blue"
        >{{ $tc("add") }}</b-button
      >
      <b-button variant="default" @click="onFetch()" class="btn-blue">{{
        $t("fetch")
      }}</b-button>
    </div>
    <!-- <div class="d-flex justify-content-end aling-items-center mb-2">
      <div class="d-flex justify-content-end mt-3 align-items-center">
        <div class="mr-1" style="white-space: nowrap">
          {{ $t("download") }} as:
        </div>

        <a
          :href="BASE_URL + `/api/admin/export_fnb_list${queryString}`"
          target="_blank"
          title="Download as Excel"
          download
        >
          <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
        </a>
      </div>
    </div> -->

    <!---List View--->
    <section class="row" v-if="listView" style="margin: 0px 0px">
      <div class="col-12 white-wrapper divScroll">
        <table>
          <tr class="fnb_list_table_header" style="text-align: center">
            <td>
              <div class="d-flex justify-content-center" v-if="copyMenuFlag">
                <b-form-checkbox
                  class="j-checkbox p-0"
                  v-b-tooltip.hover
                  :title="'Select All'"
                  v-model="selectAllFnbItems"
                  @change="onSelectAllFnbItems($event)"
                />
              </div>
            </td>
            <td style="" class="spacing-td">Code</td>
            <td style="" class="spacing-td">Report Code</td>
            <td style="" class="spacing-td">Gl-Account</td>
            <td style="" class="spacing-td">Gl-Desc</td>
            <td style="width: 2%" class="spacing-td">Color</td>
            <td style="width: 10%" class="spacing-td">F&B Item</td>
            <td style="width: 10%" class="spacing-td">Recipe</td>
            <td style="width: 10%" class="spacing-td">Category</td>
            <td style="width: 7%" class="spacing-td">Price</td>
            <td style="width: 7%" class="spacing-td">Cost Price</td>
            <td style="width: 8%" class="spacing-td">Loc</td>
            <td class="spacing-td">Diff Price</td>
            <td class="spacing-td">Recipe</td>
            <td class="spacing-td">Veg</td>
            <td class="spacing-td">Egg</td>
            <td style="width: 8%; text-align: center" class="spacing-td">
              From
            </td>
            <td style="width: 8%; text-align: center" class="spacing-td">To</td>
            <td style="width: 5%; text-align: center" class="spacing-td">
              Age
            </td>
            <td style="width: 5%; text-align: center" class="spacing-td">
              IMG
            </td>
          </tr>
          <!--1st Row-->
          <tr
            v-for="(item, itemIndex) in fnb_items"
            :key="itemIndex"
            class="light_grey_back main_border"
          >
            <!--Active/view/Edit Secion--->
            <td class="spacing-td">
              <div
                class="d-flex align-items-center"
                v-if="!copyMenuFlag"
                style="gap: 8px"
              >
                <b-form-checkbox
                  @change="updateFnbitemStatus($event, item)"
                  class="j-checkbox-list pb-0 d-flex"
                  unchecked-value="N"
                  value="Y"
                  v-model="item.item_is_active"
                  style="height: 15px"
                >
                </b-form-checkbox>
                <span
                  v-if="$can('update', 'F&B item')"
                  class="edit-pen"
                  @click="goToRoute('/fnb/edit-fnb-item', item)"
                  style="cursor: pointer"
                ></span>
                <span
                  class="icon-eye"
                  @click="goToRoute('/fnb/view-fnb-item', item)"
                  style="cursor: pointer"
                ></span>
              </div>
              <div
                class="d-flex justify-content-center py-1"
                v-else-if="copyMenuFlag"
              >
                <b-form-checkbox
                  class="j-checkbox"
                  @change="onSelectCheckboxCopyMenu($event)"
                  :value="item"
                  v-model="selectedFnbItems"
                />
              </div>
            </td>

            <!--Item Code--->
            <td class="spacing-td">{{ item.item_code }}</td>
            <!--Report Code--->
            <td class="spacing-td">{{ item.report_code }}</td>
            <!--gl Account--->
            <td class="spacing-td">{{ item.gl_account }}</td>
            <!--gl desc--->
            <td class="spacing-td">{{ item.gl_desc }}</td>

            <!--Color-->
            <td style="padding: 0px 6px" class="spacing-td">
              <div
                v-if="item.fc_bgColor"
                :style="
                  'height: 18px;background-color:' + item.fc_bgColor + ';'
                "
              ></div>
              <div v-else>-</div>
            </td>

            <!--Fnb items--->
            <td class="spacing-td">
              <span class="d-flex align-items-center" style="gap: 5px">
                <FoodMark
                  :className="'food-mark-element-inline'"
                  :isVeg="item.item_is_veg == 'Y' ? true : false"
                />
                <span>{{ item.item_name }}</span>
              </span>
            </td>
            <!-- recipe -->
            <td class="spacing-td">{{ item.recipe_name }}</td>
            <!--Food Category--->
            <td class="spacing-td">{{ item.fc_category }}</td>

            <!---Sales-->
            <td style="text-align: right" class="spacing-td">
              {{ currFormat(item.fp_total_amount) }}
            </td>

            <!---cost price-->
            <td style="text-align: right" class="spacing-td">
              {{ currFormat(item.itc_cost_price) }}
            </td>

            <!--Loc-->

            <td class="spacing-td">
              {{ item.cinema_name.slice(0, 4).toUpperCase() }}
            </td>

            <!--Diff Price--->
            <td class="spacing-td">
              <span
                style="color: green; font-weight: bold; text-align: center"
                v-if="item.diff_price > 1"
                >Yes</span
              >
              <span v-else>-</span>
            </td>

            <!--Recipe--->
            <td class="spacing-td">
              <span
                style="color: green; font-weight: bold; text-align: center"
                v-if="item.recipe_id"
                >Yes</span
              >
              <span v-else>-</span>
            </td>

            <!--Veg--->
            <td class="spacing-td">
              <span
                style="color: green; font-weight: bold; text-align: center"
                v-if="item.item_is_veg == 'Y'"
                >Yes</span
              >
              <span v-else>-</span>
            </td>

            <!--Egg--->
            <td class="spacing-td">
              <span
                style="color: green; font-weight: bold; text-align: center"
                v-if="item.includes_egg == 'Y'"
                >Yes</span
              >
              <span v-else>-</span>
            </td>

            <!--From--->
            <td style="text-align: right" class="spacing-td">
              {{
                item.fp_from_date
                  ? moment(item.fp_from_date).format("DD.MM.YYYY")
                  : "-"
              }}
            </td>

            <!--To--->
            <td style="text-align: right" class="spacing-td">
              {{
                item.fp_to_date
                  ? moment(item.fp_to_date).format("DD.MM.YYYY")
                  : "-"
              }}
            </td>

            <!--Age--->
            <td style="text-align: right" class="spacing-td">
              {{ item.item_age_restriction || 0 }}
            </td>

            <!--Image--->
            <td
              style="color: green; font-weight: bold; text-align: center"
              class="spacing-td"
            >
              {{ item.item_image_url ? "Yes" : "No" }}
            </td>
          </tr>
        </table>
      </div>
    </section>

    <!---List View--->

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView && false">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(fnb, fnbKey) in fnb_items"
        :key="fnbKey"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ fnb.item_name }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  v-if="$can('update', 'F&B item')"
                  @click="goToRoute('/fnb/edit-fnb-item', fnb)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item @click="goToRoute('/fnb/view-fnb-item', fnb)">
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1">
              <div class="count">059</div>
              <div class="text">
                No of
                <br />employees
              </div>
            </div>
            <!-- <div class="d-flex align-items-end">
              <label class="ios-switch">
                <input
                  :checked="fnb.fc_is_active == 'Y' ? true: false"
                  type="checkbox"
                  class="ios-checkbox"
                />
                <span class="switch-slider"></span>
              </label>
            </div>-->
          </div>
        </div>
      </div>
      <div v-if="fnb_items.length == 0">
        <h5>No Records Found</h5>
      </div>
    </div>

    <section v-if="gridView">
      <!--Filter--->
      <div class="row" style="">
        <div
          class="col-12 d-flex food_filter"
          style="gap: 15px; overflow-x: scroll; padding-bottom: 10px"
        >
          <button
            :class="category_id == category.fc_id ? 'activeBtn' : ''"
            class="category-chip"
            v-for="(category, categoryIndex) in CategoriesFilterArray"
            :key="categoryIndex"
            @click="onSelectCategory(category)"
          >
            {{ category.fc_category }}
          </button>
        </div>
      </div>
      <!--Filter--->

      <!---Card view--->
      <div class="row" style="margin: 20px 0px">
        <div
          class="col-3"
          v-for="(fnb, fnbKey) in fnb_items"
          :key="fnbKey"
          style="margin-bottom: 15px; max-width: 270px"
        >
          <div class="card">
            <div
              class="fnb_item_image_wrapper img-hover"
              style="cursor: pointer"
            >
              <img
                v-lazy="_GetImagePath(fnb.item_image_url)"
                @click="goToRoute('/fnb/view-fnb-item', fnb)"
                width="100%"
                height="100%"
                class=""
                style="
                  border-top-left-radius: 10px;
                  border-top-right-radius: 10px;
                "
              />
              <FoodMark
                :className="'food-mark-element-top'"
                :isVeg="fnb.item_is_veg == 'Y' ? true : false"
                :isEgg="fnb.includes_egg == 'Y' ? true : false"
              />
              <!-- <EggMark :className="'food-mark-element-top'" :isVeg="fnb.includes_egg == 'Y' ? true : false"/> -->
            </div>
            <div class="card-container justify-content-center">
              <div class="d-flex justify-content-between">
                <div class="positioning-check">
                  <b-form-checkbox
                    class="j-checkbox-new"
                    unchecked-value="N"
                    value="Y"
                    @change="updateFnbitemStatus($event, fnb)"
                    v-model="fnb.item_is_active"
                  >
                  </b-form-checkbox>
                </div>

                <div class="d-flex justify-content-center">
                  <h4
                    class="textellipse"
                    style="font-size: 14px; margin-bottom: 0px"
                    v-b-tooltip.hover
                    :title="fnb.item_name"
                  >
                    {{ fnb.item_name }}
                  </h4>
                </div>

                <div class="positioning-name">
                  <p style="margin-bottom: 0px">
                    {{ currFormat(fnb.fp_total_amount) }} <b></b>
                  </p>
                </div>
              </div>

              <div style="padding-top: 3px" v-if="false">
                <b-form-checkbox
                  switch
                  unchecked-value="N"
                  value="Y"
                  v-model="fnb.item_is_active"
                  name="check-button"
                >
                </b-form-checkbox>
              </div>
            </div>

            <!--div class="card-container">
              <div>
                <p style="margin-bottom: 0px" v-if="false">
                  {{ currFormat(fnb.fp_total_amount) }} <b></b>
                </p>
              </div>
              <div class="d-flex" style="gap: 10px" v-if="false">
                <p style="margin-bottom: 0px" v-if="fnb.item_is_active == 'Y'">
                  Active
                </p>
                <p
                  style="margin-bottom: 0px"
                  v-if="fnb.item_is_active == 'N' && 'inactive'"
                >
                  Inactive
                </p>
                <p style="margin-bottom: 0px">
                  <b-form-checkbox
                    class="j-checkbox-new"
                    unchecked-value="N"
                    value="Y"
                    @change="updateFnbitemStatus($event, fnb)"
                    v-model="fnb.item_is_active"
                  >
                  </b-form-checkbox>

                  <StatusDot
                    @click="onchangestatus(fnb)"
                    :status="
                      fnb.item_is_active == 'Y'
                        ? 'active '
                        : fnb.item_is_active == 'N' && 'inactive'
                    "
                    v-if="false"
                  />
                </p>
              </div>
            </div---->
            <div class="card-container align-items-center">
              <div>
                <h4
                  style="font-size: 12px; margin-bottom: 0px"
                  v-if="fnb.cinema_name == 'Y' && false"
                >
                  {{ fnb.cinema_name }}
                </h4>
                <h4 style="font-size: 12px; margin-bottom: 0px">
                  {{ fnb.item_code }}
                </h4>
              </div>

              <div style="display: none">
                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item
                    v-if="$can('update', 'F&B item')"
                    @click="goToRoute('/fnb/edit-fnb-item', fnb)"
                  >
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="goToRoute('/fnb/view-fnb-item', fnb)"
                  >
                    <span class="icon-eye mr-1"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>

              <div class="d-flex" style="gap: 5px; align-items: center">
                <span
                  v-if="$can('update', 'F&B item')"
                  class="edit-pen"
                  @click="goToRoute('/fnb/edit-fnb-item', fnb)"
                  style="cursor: pointer"
                ></span>
                <span
                  class="icon-eye d-none"
                  @click="goToRoute('/fnb/view-fnb-item', fnb)"
                  style="cursor: pointer"
                ></span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="fnb_items.length == 0" class="no-records-box">
          <div class="text-center">
            <img
              src="@/assets/img/icons/pos-fnb-no-itmes.svg"
              height="75"
              width="75"
            />
            <br />
            <div>No Item Found</div>
          </div>
        </div>
      </div>
    </section>
    <!---Card view--->
    <!-- LIST VIEW DESIGNATION -->
    <table class="list-view-table" v-if="listView && false">
      <thead>
        <tr>
          <th>
            <img
              v-if="this.columnName != 'item_name'"
              @click="onSortValue('item_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('item_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('item_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $t("fnbitems") }}
          </th>
          <!-- <th>{{ $t('view') }} {{ $tc('recipe', 1) }}</th> -->
          <th>{{ $tc("status", 1) }}</th>
          <th class="text-right">
            <span class="pr-5">{{ $t("image") }}</span>
          </th>
        </tr>
      </thead>

      <tbody v-if="fnb_items.length > 0">
        <tr v-for="(fnb, fnbKey) in fnb_items" :key="fnbKey">
          <td>{{ fnb.item_name }}</td>
          <!-- <td>
            <button
              v-if="fnb.recipe_id && fnb.recipe_id > 0"
              class="btn-blue"
              @click="goToRouteRecipe('/fnb/view-recipe',fnb)"
            >{{ $t('view recipe') }}</button>
          </td> -->
          <td>
            <!-- <label class="ios-switch">
              <input
                :checked="fnb.item_is_active == 'Y' ? true : false"
                type="checkbox"
                class="ios-checkbox"
                disabled
              />
              <span class="switch-slider"></span>
            </label> -->
            <StatusDot
              :status="
                fnb.item_is_active == 'Y'
                  ? 'active'
                  : fnb.item_is_active == 'N' && 'inactive'
              "
            />
          </td>
          <td>
            <div class="d-flex align-items-center justify-content-end">
              <img
                v-lazy="_GetImagePath(fnb.item_image_url)"
                width="100"
                height="100"
              />

              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  v-if="$can('update', 'F&B item')"
                  @click="goToRoute('/fnb/edit-fnb-item', fnb)"
                >
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item @click="goToRoute('/fnb/view-fnb-item', fnb)">
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="3">
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>

    <b-pagination
      v-if="rows > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>

    <!---Download Button-->

    <b-modal
      id="copyMenuModal"
      ref="copyMenuModal"
      title="Copy Menu"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      no-fade
    >
      <div class="container">
        <p class="my-1">Select Cinema(s) to Paste Selected Menu</p>

        <div class="row mx-auto mb-4">
          <div class="col-12 mb-3">
            <multiselect
              v-model="selectedFnbItems"
              :placeholder="'Selected Items'"
              :options="fnb_items"
              label="item_name"
              track-by="item_id"
              :multiple="true"
            ></multiselect>
          </div>
          <div class="col-12">
            <multiselect
              v-model="CinemasCopyMenu"
              :placeholder="'Cinema'"
              :options="CopyMenuCinemaList"
              label="cine_name"
              track-by="cine_id"
              :multiple="true"
            ></multiselect>
          </div>
        </div>

        <div class="text-center">
          <button
            class="btn-outline-blue"
            @click.prevent.stop="onCancelCopyMenu"
          >
            Cancel
          </button>
          <span class="mx-1"></span>
          <button
            class="btn btn-blue px-4 fs-14"
            @click.prevent.stop="handleCopyMenu"
          >
            {{ "Submit" }}
          </button>
        </div>
      </div>
    </b-modal>

    <!---Download Button-->
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import PosFnbService from "@/services/PosFnbService";
  import { BASEURL } from "@/config/index.js";
  import StatusDot from "@/components/Partials/StatusDot.vue";
  import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import _ from "lodash";
  import moment from "moment";
  import { createQueryString } from "@/services/ApiHelper";
  import { EventBus } from "@/main";
  import FoodMark from "@/components/UIElements/VegMark.vue";

  export default {
    components: {
      StatusDot,
      FilterByStatusDropdown,
      NoRecords,
      FoodMark,
    },
    data() {
      return {
        CinemasCopyMenu: [],
        selectedFnbItems: [],
        selectAllFnbItems: false,
        copyMenuFlag: false,
        selectedCategoryFilter: "All",
        category_id: 0,
        cinemasSelected: "",
        Cinemas: [],
        checked: true,
        text: "active",
        perPage: 10,
        currentPage: 1,
        rows: 0,
        selectedvalue: "10",
        cinema_id: null,
        gridView: true,
        listView: false,
        fnb_items: [],
        URL_BASE: BASEURL,
        searchValue: "",
        noCinemaCopyMenu: false,
        //sorting
        isSort: false,
        isAscending: false,
        columnName: "",
        orderBy: "",
        CategoriesFilterArray: [],
        fnb_status: "Y",
        non_sellable_filter: "S",
        selectedTypeFilter: {
          id: 2,
          flag: "S",
          name: "Sellable",
        },
        fillterArray: [
          {
            id: 1,
            flag: "NS",
            name: "Non-Sellable",
          },
          {
            id: 2,
            flag: "S",
            name: "Sellable",
          },
          {
            id: 3,
            flag: null,
            name: "All",
          },
        ],
      };
    },

    watch: {
      "$route.query": {
        handler(newVal, oldVal) {
          console.log("!_.isEqual(newVal, oldVal", !_.isEqual(newVal, oldVal));
          if (!_.isEqual(newVal, oldVal)) {
            // this.fnb_status = newVal.status;
            console.log({ newVal: { ...newVal }, oldVal: { ...oldVal } });
            const currentPageFromUrl = parseInt(newVal.currentPage) || 1;
            const currentSearchFromUrl = newVal.searchValue;
            const currentFilterFromUrl = newVal.filter;
            const currentperPageFromUrl = newVal.perPage;
            const currentpageStatus = newVal.status;
            const currentpageCategory = newVal.category_id;

            this.$nextTick(() => {
              if (!!currentPageFromUrl) {
                this.currentPage = currentPageFromUrl;
              }
              if (!!currentFilterFromUrl) {
                this.fnb_status = currentFilterFromUrl;
              } else {
                this.fnb_status = "Y";
              }
              if (!!currentpageCategory) {
                this.category_id = currentpageCategory;
              }
              if (!!currentpageStatus) {
                this.fnb_status = currentpageStatus;
                // this.updateDropDownStatus(this.fnb_status);
                // setTimeout(() => {
                //   EventBus.$emit("STATUS_CHANGE", currentpageStatus);
                // }, 1);

                // this.onSwitchActive(this.fnb_status);
              } else {
                this.fnb_status = "Y";
              }
              if (!!currentSearchFromUrl) {
                this.searchValue = currentSearchFromUrl;
              }
              if (!!currentperPageFromUrl) {
                this.perPage = currentperPageFromUrl;
              }

              if (!_.isEqual(newVal, oldVal)) {
                // //this.getFnbItems();
              }

              this.updateDropDownStatus(this.fnb_status);
            });
          }
        },
        deep: true,
        immediate: true,
      },
    },
    computed: {
      CopyMenuCinemaList() {
        let filteredCinemas = _.cloneDeep(this.Cinemas);
        if (this.cinema_id) {
          filteredCinemas = filteredCinemas.filter(
            (x) => x.cine_id !== this.cinema_id
          );
        }
        return filteredCinemas;
      },
      queryString() {
        let queryString = ``;
        let payload = {
          limit: this.perPage,
          currentPage: this.currentPage,
          searchValue: this.searchValue,
          columnName: this.columnName,
          orderBy: this.orderBy,
          cinema_id: this.cinema_id,
          category_id: this.category_id,
          filterIsActive: this.fnb_status,
          withPricing: true,
        };
        queryString = this.createQueryString(payload);
        return queryString;
      },
      viewingRange() {
        if (this.rows === 0) {
          return "Viewing 0 to 0 of 0";
        }

        const start = (this.currentPage - 1) * this.perPage + 1;
        const end = Math.min(this.currentPage * this.perPage, this.rows);

        return `Viewing ${start} to ${end} of ${this.rows}`;
      },
    },
    mounted() {
      this.cinema_id = this.secureStore.get("USINFO").cinema_id;
       this.getCinemaList(this.cinema_id);
      // //this.getFnbItems();
    },
    beforeMount() {
      this.getviewingnumber();
      this.getFnbCategoriesLabel();
    },
    beforeRouteUpdate(to, from, next) {
      if (to.fullPath == from.fullPath) {
        console.log("Same route beforeRouteLeave", { to: to, from: from });
        return false;
      } else {
        console.log("change beforeRouteLeave", { to: to, from: from });
        next();
      }
    },
    methods: {
      moment,
      createQueryString,
      onFetch: function() {
        if (this.cinemasSelected) {
          this.getFnbItems();
        } else {
          this.$toasted.show("select cinema");
        }
      },
      onSelectFilterType(event, type) {
        if (type == "REMOVE") {
          this.non_sellable_filter = null;
        } else {
          this.non_sellable_filter = event["flag"];
        }
        this.getFnbItems();
      },
      onCancelCopyMenu() {
        this.copyMenuFlag = false;
        this.noCinemaCopyMenu = false;
        this.selectedFnbItems = [];
        this.CinemasCopyMenu = [];
        this.selectAllFnbItems = false;
      },
      handleCopyMenu() {
        this.$refs.copyMenuModal.hide();
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.cinema_id,
          fnb_items: this.selectedFnbItems,
          cinema_copy_list: this.CinemasCopyMenu,
        };

        PosFnbService.CopyFnbMenuPriceByCinema(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.getFnbItems();
              this.onCancelCopyMenu();
              this.getFnbItems();
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message || "Failed to Update");
            }
          })
          .catch((err) => {
            console.log("Error:", err);
            this.$toasted.show("Something Went Wrong!");
          })
          .finally(() => {
            loader.hide();
          });
      },
      onClickCopyItems() {
        console.log("this.selectedFnbItems", this.selectedFnbItems);
        if (this.cinema_id) {
          console.log("this.selectedFnbItems", this.selectedFnbItems);
          this.$refs.copyMenuModal.show();
        } else {
          this.$toasted.show("Please Select Cinema");
        }
      },
      onSelectAllFnbItems(event) {
        if (event) {
          this.selectedFnbItems = _.cloneDeep(this.fnb_items);
        } else {
          this.selectedFnbItems = [];
        }
      },
      onSelectCheckboxCopyMenu() {
        if (this.selectAllFnbItems) {
          this.selectAllFnbItems = false;
        }
      },
      onClickCopyMenuOption() {
        this.gridView = false;
        this.listView = true;
        this.noCinemaCopyMenu = false;
        if (!this.cinema_id) {
          this.noCinemaCopyMenu = true;
          this.$toasted.show("Please Select Cinema");
        } else {
          this.noCinemaCopyMenu = false;
          this.copyMenuFlag = true;
        }
      },
      updateDropDownStatus(status) {
        console.log("HITTING STTAUS CHANGE");
        let text = "Active";
        if (status == "Y") {
          text = "Active";
        } else if (status == "N") {
          text = "Inactive";
        } else {
          text = "All";
        }
        this.$refs.statusDropDown.onChangeFilterIsActive(text);
      },
      onSelectCategory(category) {
        let q = {
          ...this.$route.query,
          category_id: category.fc_id,
        };
        this.$router.push({ query: q });
        this.selectedCategoryFilter = category;
        this.category_id = category.fc_id;
        this.getFnbItems();
      },
      updateFnbitemStatus(status, item) {
        let loader = this.$loading.show();
        let payload = {
          item_id: item.item_id,
          status: status,
        };
        PosFnbService.UpdateFnbItemStatus(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.$toasted.show(data.message);
              this.getFnbItems();
            } else {
              console.log("Error", data.message);
            }
          })
          .catch((err) => {
            console.log("Error", err);
          })
          .finally(() => {
            loader.hide();
          });
      },
      getFnbCategoriesLabel() {
        PosFnbService.GetFnbCategoriesLabels()
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records && data.Records.length > 0) {
              this.CategoriesFilterArray = data.Records;
              let obj = {
                FnbCategoryContent: [],
                fc_bgColor: null,
                fc_category: "All",
                fc_fontColor: null,
                fc_icon_active_url: "",
                fc_icon_url: "",
                fc_id: 0,
                fc_is_active: "Y",
                fc_order: 1,
                fc_parent_id: 0,
                totalCategoryFnbItems: data.Records.length,
              };
              this.CategoriesFilterArray.unshift(obj);
              console.log(
                "this.CategoriesFilterArray",
                this.CategoriesFilterArray
              );
            } else {
              this.CategoriesFilterArray = [];
              console.log("Error", data.message);
            }
          })
          .catch((err) => {
            console.log("Error", err);
          });
      },
      onSelectCinema(cinemaObj) {
        this.cinemasSelected = cinemaObj;
        this.cinema_id = cinemaObj.cine_id;
        this.currentPage = 1;
        this.$router
          .push({
            query: { ...this.$route.query, currentPage: 1 },
          })
          .finally(() => {
            // //this.getFnbItems();
          });
      },
      onRemoveCinema(cinemaObj) {
        this.cinemasSelected = "";
        this.cinema_id = null;
        this.currentPage = 1;
        this.$router
          .push({
            query: { ...this.$route.query, currentPage: 1 },
          })
          .finally(() => {
            // //this.getFnbItems();
          });
      },
      getCinemaList: function(cinema_id) {
        MasterService.GetCinemas({ cine_id: cinema_id || this.cinema_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
              if (data.Records && data.Records.length === 1) {
                this.cinemasSelected = data.Records[0];
                this.onSelectCinema(data.Records[0]);
              }
            } else {
              // Show Error Message
              this.$toasted.show(data.message);
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            console.log("Catch On GetActiveCinemas :", error);
          });
      },

      onchangestatus(fnb) {
        console.log(fnb, "test");
        fnb.item_is_active = fnb.item_is_active == "Y" ? "N" : "Y";
        this.getFnbItems();
      },
      searchFnbItem(search, keyboardEvent) {
        let q = {
          ...this.$route.query,
          searchValue: !!search ? search : undefined,
          currentPage: "1",
          perPage: this.perPage,
        };
        this.$router
          .push({ query: q })
          .catch(() => {})
          .finally((_) => {
            this.getFnbItems();
          });
      },
      onSortValue(columnName, orderBy) {
        this.isSort = true;
        this.isAscending = !this.isAscending;
        this.columnName = columnName;
        this.orderBy = orderBy;
        this.getFnbItems();
      },
      getviewingnumber() {
        this.viewingnumbers = [
          { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
        ];
      },
      onDropDownChangeValue(event) {
        let q = { ...this.$route.query };
        let perPagevalue = this.rows;
        if (event !== "All") {
          perPagevalue = event;
        }

        this.$router
          .push({
            query: { ...q, perPage: !!perPagevalue ? perPagevalue : undefined },
          })
          .catch(() => {})
          .finally(() => {
            if (event == "All") {
              this.perPage = this.rows;
              this.selectedvalue = event;
              this.currentPage = 1;
              this.getFnbItems();
            } else {
              console.log("Numbers :", event);
              this.selectedvalue = event;
              this.perPage = event;
              console.log("perPage :", this.perPage);
              this.currentPage = 1;
              this.getFnbItems();
            }
          });
      },
      /* eslint-disable */
      onChangePagination: function(event) {
        this.$router
          .push({
            query: { ...this.$route.query, currentPage: !!event ? event : 1 },
          })
          .catch(() => {})
          .finally((_) => {
            console.log(event);
            if (event === undefined) {
              this.currentPage = 1;
              this.getFnbItems();
            } else {
              this.currentPage = event;
              this.getFnbItems();
            }
          });
      },
      /* option: ('Y' | 'N' | 'A' | 'U') */
      onSwitchActive: function(option) {
        console.log("Hitting onSwitchActive", option);
        this.fnb_status = !!option ? option : "Y";

        this.$router
          .push({
            query: {
              ...this.$route.query,
              status: !!option ? option : undefined,
              currentPage: this.currentPage || 1,
              perPage: this.perPage,
            },
          })
          .catch(() => {})
          .finally(() => {
            //this.getMovies();
          });
      },
      getFnbItems: function(check) {
        console.log("");
        if (!!this.$route.query.currentPage) {
          this.currentPage = this.$route.query.currentPage;
        }
        if (!!this.$route.query.status) {
          this.fnb_status = this.$route.query.status;
        }
        if (!!this.$route.query.searchValue) {
          this.searchValue = this.$route.query.searchValue;
        }
        if (!!this.$route.query.category_id) {
          this.category_id = this.$route.query.category_id;
        }

        this.fnb_items = [];
        let payload = {
          limit: this.perPage,
          currentPage: this.currentPage,
          searchValue: this.searchValue,
          columnName: this.columnName,
          orderBy: this.orderBy,
          cinema_id: this.cinema_id,
          category_id: this.category_id,
          filterIsActive: this.fnb_status,
          non_sellable_filter: this.non_sellable_filter || null,
          withPricing: true,
        };
        let loader = this.$loading.show();
        PosFnbService.GetAllFnBItems(payload)
          .then((response) => {
            const { data } = response;
            console.log("response:", response);
            if (data && data.status && data.Records.length > 0) {
              this.fnb_items = data.Records;
              if (this.noCinemaCopyMenu) {
                this.copyMenuFlag = true;
              }
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
                this.selectedvalue =
                  this.selectedvalue < 10 ? 10 : this.selectedvalue;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.fnb_items = [];
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
              // this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally((_) => {
            setTimeout(() => loader.hide(), 0);
            // this.$forceUpdate();
          });
      },
      goToRoute: function(path, item) {
        const { item_code, item_is_active } = item;
        this.$router.push({
          path: path,
          query: {
            item_code: item_code,
            item_is_active: item_is_active,
          },
        });
      },
      goToRouteRecipe: function(path, { recipe_id }) {
        this.$router.push({
          path: path,
          query: {
            recipe_id: recipe_id,
          },
        });
      },
      /* eslint-disable */

      viewType: function(viewType) {
        if (viewType == "gridView") {
          this.gridView = true;
          this.listView = false;
        } else if ((viewType = "listView")) {
          this.listView = true;
          this.gridView = false;
        }
      },
    },
  };
</script>
<style>
  .fnb_item_image_wrapper img {
    object-fit: cover;
    aspect-ratio: 460/280;
  }
  td {
    /*border: 1px solid black;
  padding: 4px;
  text-align: left;
  font-weight: 500;*/
  }
  .no-records-box {
    height: calc(100vh - 300px);
    background: white;
    width: 100%;
    padding: 20px;
    border: 1px solid lightgrey;
    border-radius: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .fnb_list_table_header td {
    background: #1a427d2b;
    font-weight: bold;
    border: 1px solid black;
  }
  .main_border td {
    border: 1px solid black;
  }
  .spacing-td {
    padding: 5px;
  }
  .light_grey_back:nth-child(odd) {
    background-color: #fff;
  }
  .positioning-check {
    position: absolute;
    left: 0;
    margin-left: 5px;
  }
  .positioning-name {
    position: absolute;
    right: 0;
    margin-right: 5px;
  }
  .h-29 {
    height: 29px !important;
  }

  .food-mark-space {
    display: flex;
    gap: 5px;
    align-items: center;
    border: none;
  }

  .divScroll {
    /* width: 5px; */
    overflow-x: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/FnBComponents/fnbItems.vue